export const DELETED_IS_SUCCESS = "DELETED_IS_SUCCESS ";
